<div
  class="gw-mt-6 gw-border-base gw-bg-background-elevation-2 md:gw-rounded-2xl"
>
  <div
    class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-neutral-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-px-4 md:gw-px-6"
  >
    <p class="gw-text-[16px] gw-text-text-primary gw-font-bold">
      {{ 'features.checkouts.wizard.items.sectionTitle' | translate }}
    </p>

    <gatewee-button
      [title]="'features.checkouts.wizard.items.addItem' | translate"
      variant="secondary"
      iconName="@tui.plus"
      class="gw-w-full gw-max-w-[160px] md:gw-max-w-[170px]"
      (clicked)="addItemForm()"
    ></gatewee-button>
  </div>

  <div
    *ngIf="itemsArray.length === 0"
    class="gw-flex gw-flex-col md:gw-flex-row gw-gap-[16px] gw-border-base gw-items-center gw-bg-background-neutral-1 md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
  >
    <gatewee-icon
      icon="@tui.info"
      iconStyle="outline"
      size="24px"
    ></gatewee-icon>
    <div class="gw-col">
      <p class="gw-text-text-primary gw-text-[16px] gw-font-bold">
        {{ 'features.checkouts.wizard.items.emptyTitle' | translate }}
      </p>
      <p class="gw-text-text-secondary">
        {{ 'features.checkouts.wizard.items.emptyHint' | translate }}
      </p>
    </div>
  </div>

  <div
    *ngFor="let form of itemsArray.controls; let i = index"
    class="gw-border-base gw-bg-background-neutral-1 md:gw-m-x-large gw-m-medium gw-px-[16px] gw-py-[16px] gw-rounded-2xl"
  >
    <ng-container *ngIf="!saved[i]; else savedView">
      <form [formGroup]="$any(form)" class="gw-rounded-2xl">
        <div class="gw-flex gw-justify-start gw-items-center gw-mb-4">
          <p class="gw-font-bold gw-text-text-primary">
            {{
              'features.checkouts.wizard.items.itemNumber'
                | translate : {n: i + 1}
            }}
          </p>
        </div>

        <div class="gw-mb-6">
          <div class="gw-flex-col md:gw-flex gw-gap-6">
            <div>
              <label class="gw-font-bold gw-text-text-primary">
                {{ 'features.checkouts.wizard.items.productImage' | translate }}
              </label>

              <div class="gw-flex gw-gap-6 gw-mb-3 gw-mt-small">
                <gatewee-radio-button
                  formControlName="imageSource"
                  [label]="
                    'features.checkouts.wizard.items.imageLimited' | translate
                  "
                  name="imageSource"
                  value="url"
                  (change)="setImageSource(i, 'url')"
                >
                </gatewee-radio-button>

                <gatewee-radio-button
                  formControlName="imageSource"
                  [label]="
                    'features.checkouts.wizard.items.imageUpload' | translate
                  "
                  name="imageSource"
                  value="upload"
                  (change)="setImageSource(i, 'upload')"
                >
                </gatewee-radio-button>
              </div>
            </div>

            <div
              class="gw-w-full"
              *ngIf="$any(form.get('imageSource')?.value) === 'url'"
            >
              <gatewee-input
                [form]="$any(form)"
                [label]="'features.checkouts.wizard.items.imageUrl' | translate"
                controlName="imageUrl"
                type="text"
                [placeholder]="
                  'features.checkouts.wizard.items.imageUrlPlaceholder'
                    | translate
                "
                iconName="@tui.link"
              ></gatewee-input>
            </div>

            <div
              class="gw-w-full"
              *ngIf="$any(form.get('imageSource')?.value) === 'upload'"
            >
              <gatewee-upload
                [control]="$any(form.get('imageFile'))"
                [previewControl]="$any(form.get('imagePreview'))"
                [title]="
                  'features.checkouts.wizard.items.uploadTitle' | translate
                "
                [label]="
                  'features.checkouts.wizard.items.uploadLabel' | translate
                "
                [subtitle]="
                  'features.checkouts.wizard.items.uploadSubtitle' | translate
                "
              ></gatewee-upload>
            </div>
          </div>
        </div>

        <div class="gw-form-row gw-items-end">
          <div class="gw-w-full md:gw-flex-1">
            <gatewee-input-v2
              [form]="$any(form)"
              [label]="'features.checkouts.wizard.items.name' | translate"
              controlName="name"
              type="text"
              [placeholder]="
                'features.checkouts.wizard.items.namePlaceholder' | translate
              "
              [required]="true"
            ></gatewee-input-v2>
          </div>

          <div class="gw-w-full md:gw-flex-1">
            <gatewee-input-v2
              [form]="$any(form)"
              [label]="'features.checkouts.wizard.items.quantity' | translate"
              controlName="quantity"
              type="number"
              [placeholder]="
                'features.checkouts.wizard.items.quantityPlaceholder'
                  | translate
              "
              [required]="true"
            ></gatewee-input-v2>
          </div>

          <div class="gw-w-full md:gw-flex-1">
            <gatewee-input-v2
              [form]="$any(form)"
              [label]="'features.checkouts.wizard.items.price' | translate"
              controlName="price"
              type="currency"
              [placeholder]="
                'features.checkouts.wizard.items.pricePlaceholder' | translate
              "
              [required]="true"
              iconName="@tui.circle-dollar-sign"
            ></gatewee-input-v2>
          </div>
        </div>

        <div class="gw-w-full gw-mt-x-large">
          <label class="gw-form-label">{{
            'features.checkouts.wizard.items.description' | translate
          }}</label>
          <textarea
            class="gw-textarea-base placeholder:gw-text-text-tertiary"
            formControlName="description"
            [placeholder]="
              'features.checkouts.wizard.items.descriptionPlaceholder'
                | translate
            "
          ></textarea>
        </div>

        <div class="gw-flex gw-justify-end gw-mt-6 gw-gap-4">
          <gatewee-button
            [title]="'common.actions.cancel' | translate"
            variant="outline"
            class="gw-w-full md:gw-max-w-[120px] gw-text-[14px]"
            (clicked)="removeSingle(i)"
          ></gatewee-button>
          <gatewee-button
            [title]="'common.actions.save' | translate"
            variant="primary"
            class="gw-w-full md:gw-max-w-[120px] gw-text-[14px]"
            [disabled]="$any(form.invalid)"
            (clicked)="saveSingle(i)"
          ></gatewee-button>
        </div>
      </form>
    </ng-container>

    <ng-template #savedView>
      <div
        class="gw-flex gw-flex-col md:gw-flex-row gw-items-start md:gw-items-center gw-justify-between gw-gap-4"
      >
        <span class="gw-hidden md:gw-block">
          <gatewee-icon
            icon="@tui.trash"
            iconStyle="primary"
            size="20px"
            class="border-icon gw-border-icon-primary gw-rounded-lg gw-p-2 gw-cursor-pointer"
            (click)="removeSingle(i)"
          ></gatewee-icon>
        </span>
        <div
          class="gw-flex gw-w-full gw-flex-col md:gw-flex-row md:gw-items-center md:gw-gap-[48px] gw-gap-[24px]"
        >
          <div
            *ngIf="formSaved[i]?.imagePreview"
            class="gw-relative gw-inline-flex gw-items-center"
          >
            <img
              [src]="formSaved[i]?.imagePreview"
              [alt]="'features.checkouts.wizard.items.thumbAlt' | translate"
              class="gw-rounded-xl gw-border-base gw-w-[64px] gw-h-[64px] gw-object-cover"
            />

            <button
              type="button"
              class="gw-absolute gw-right-[-10px] gw-top-1/2 -gw-translate-y-1/2 gw-w-[38px] gw-h-[38px] gw-rounded-xl gw-bg-background-accent-1 gw-text-white gw-shadow-md gw-flex gw-items-center gw-justify-center hover:gw-opacity-90"
              (click)="
                openImagePreview(
                  formSaved[i]?.imagePreview,
                  formSaved[i]?.description,
                  formSaved[i]?.name
                )
              "
              [attr.aria-label]="
                'features.checkouts.wizard.items.viewImageAria' | translate
              "
            >
              <gatewee-icon
                icon="@tui.eye"
                iconStyle="on-accent"
                class="gw-text-[18px]"
              ></gatewee-icon>
            </button>
          </div>

          <div class="gw-full gw-max-[171px]">
            <p class="gw-font-bold gw-text-text-primary">
              {{ 'features.checkouts.wizard.items.name' | translate }}
            </p>
            <p class="gw-text-text-secondary">
              {{
                formSaved[i]?.name ||
                  ('features.checkouts.wizard.items.notInformed' | translate)
              }}
            </p>
          </div>

          <div class="gw-full gw-max-[171px]">
            <p class="gw-font-bold gw-text-text-primary">
              {{ 'features.checkouts.wizard.items.quantity' | translate }}
            </p>
            <p class="gw-text-text-secondary">
              {{
                formSaved[i]?.quantity ||
                  ('features.checkouts.wizard.items.notInformed' | translate)
              }}
            </p>
          </div>

          <div class="gw-full gw-max-[171px]">
            <p class="gw-font-bold gw-text-text-primary">
              {{ 'features.checkouts.wizard.items.price' | translate }}
            </p>
            <p class="gw-text-text-secondary">
              {{
                formSaved[i]?.price
                  ? (formSaved[i]?.price
                    | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR')
                  : ('features.checkouts.wizard.items.notInformed' | translate)
              }}
            </p>
          </div>

          <div class="gw-full gw-max-[171px]">
            <p class="gw-font-bold gw-text-text-primary">
              {{ 'features.checkouts.wizard.items.description' | translate }}
            </p>
            <p class="gw-text-text-secondary">
              {{
                formSaved[i]?.description ||
                  ('features.checkouts.wizard.items.notInformed' | translate)
              }}
            </p>
          </div>
        </div>

        <div class="gw-flex gw-w-full md:gw-w-auto gw-gap-medium">
          <gatewee-button
            [title]="'common.actions.edit' | translate"
            variant="outline"
            class="gw-w-full md:gw-w-[104px] gw-text-[14px]"
            iconName="@tui.pencil"
            (clicked)="edit(i)"
          ></gatewee-button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #imagePreview let-image="data">
  <div
    class="gw-flex gw-flex-col gw-w-full gw-min-w-0 gw-max-w-[860px] gw-mx-auto gw-box-border gw-p-4 md:gw-p-6"
  >
    <div
      class="gw-flex gw-flex-col gw-w-full gw-min-w-0 gw-rounded-[28px] gw-bg-[#2F3A4A] gw-p-4 md:gw-p-6"
    >
      <div
        class="gw-relative gw-flex gw-flex-col gw-w-full gw-min-w-0 gw-rounded-[22px] gw-bg-white gw-p-4 gw-pt-12 md:gw-p-6 md:gw-pt-14"
      >
        <span
          class="gw-absolute gw-left-4 gw-top-4 md:gw-left-6 md:gw-top-6 gw-z-10 gw-inline-flex gw-items-center gw-rounded-full gw-bg-[#3B4656] gw-text-white gw-text-[12px] gw-leading-[16px] gw-px-4 gw-py-2"
        >
          {{ 'features.checkouts.wizard.items.previewBadge' | translate }}
        </span>

        <div
          class="gw-flex gw-w-full gw-min-w-0 gw-flex-col gw-items-center gw-justify-center gw-min-h-[280px] md:gw-min-h-[420px] lg:gw-min-h-[480px]"
        >
          <img
            [src]="image.src"
            [alt]="'features.checkouts.wizard.items.imageAlt' | translate"
            class="gw-block gw-h-auto gw-max-h-[62vh] gw-w-full gw-max-w-full gw-object-contain gw-rounded-[18px]"
          />
        </div>
      </div>
    </div>

    <div
      class="gw-mt-4 gw-w-full gw-min-w-0 gw-shrink-0 gw-rounded-2xl gw-bg-background-elevation-1 gw-border-base gw-p-4 md:gw-p-5"
    >
      <div class="gw-flex gw-items-center gw-gap-3 gw-mb-2">
        <span
          class="gw-w-[4px] gw-h-[18px] gw-rounded-full gw-bg-border-normal"
        ></span>
        <p class="gw-m-0 gw-font-bold gw-text-text-primary">
          {{ 'features.checkouts.wizard.items.name' | translate }}
        </p>
      </div>

      <p
        class="gw-m-0 gw-text-text-secondary gw-leading-[22px] gw-max-h-[120px] gw-overflow-auto"
      >
        {{
          image.name ||
            ('features.checkouts.wizard.items.notInformed' | translate)
        }}
      </p>

      <div class="gw-flex gw-items-center gw-gap-3 gw-mb-2 gw-mt-4">
        <span
          class="gw-w-[4px] gw-h-[18px] gw-rounded-full gw-bg-border-normal"
        ></span>
        <p class="gw-m-0 gw-font-bold gw-text-text-primary">
          {{ 'features.checkouts.wizard.items.description' | translate }}
        </p>
      </div>

      <p
        class="gw-m-0 gw-text-text-secondary gw-leading-[22px] gw-max-h-[120px] gw-overflow-auto"
      >
        {{
          image.description ||
            ('features.checkouts.wizard.items.notInformed' | translate)
        }}
      </p>
    </div>
  </div>
</ng-template>
